import React from "react";
import { Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { makeSelectUser } from "./containers/App/selectors";

export const ProtectedRoute = ({ children, ...rest }) => {
  const user = useSelector(makeSelectUser());
  return user ? children : <Navigate to="/login" replace />;
};
